import React from 'react';
import { Chip } from '@mui/material';

interface AndConnectorProps {
  onToggleLogic?: () => void; // Future: support OR logic
  disabled?: boolean;
  show: boolean; // Only show for non-last rows
}

const AndConnector: React.FC<AndConnectorProps> = ({ onToggleLogic, disabled = false, show }) => {
  if (!show) {
    return null;
  }

  return (
    <Chip
      label="AND"
      size="small"
      clickable={!!onToggleLogic}
      onClick={onToggleLogic}
      disabled={disabled}
      sx={{
        backgroundColor: '#1976d2',
        color: 'white',
        fontWeight: 600,
        fontSize: '12px',
        height: 24,
        minWidth: 50,
        cursor: onToggleLogic ? 'pointer' : 'default',
        '&:hover': onToggleLogic
          ? {
              backgroundColor: '#1565c0',
            }
          : {},
        '&.Mui-disabled': {
          backgroundColor: '#ccc',
          color: '#888',
        },
      }}
    />
  );
};

export default AndConnector;
